import React from 'react';
import './IconButton.css';

function IconButton({
  children,
  'aria-label': ariaLabel,
  variant = 'ghost',
  size = 'md',
  disabled = false,
  type = 'button',
  className = '',
  onClick,
  ...rest
}) {
  if (!ariaLabel) {
    // eslint-disable-next-line no-console
    console.warn('IconButton: missing required aria-label');
  }

  const classes = [
    'ui-icon-btn',
    `ui-icon-btn--${variant}`,
    `ui-icon-btn--${size}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      aria-label={ariaLabel}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
}

export default IconButton;
